export default __webpack_public_path__ + "static/media/black-add-edit-data-icon.954b6ffc.svg";